// /**
//  * Page Context Utilities
//  * Manages page-level context and metadata
//  */

// import { ANALYTICS_CONFIG } from './constants.js';

// // Cache for current page context
// let current_page_context = {
//   type: '',
//   template: '',
//   category: '',
//   title: '',
//   id: '',
//   url: '',
//   referrer: ''
// };

// /**
//  * Initialize page context from route
//  * @param {Object} route - Vue Router route object
//  * @returns {Object} - Page context object
//  */
// export function initialize_page_context(route = {}) {
//   const page_context = {
//     type: route_to_page_type(route),
//     template: get_template_from_route(route),
//     category: get_category_from_route(route),
//     title: get_page_title(route),
//     id: get_page_id(route),
//     url: get_page_url(),
//     referrer: get_referrer()
//   };

//   current_page_context = { ...page_context };
//   return page_context;
// }

// /**
//  * Update page context on route change
//  * @param {Object} route - Vue Router route object
//  * @returns {Object} - Updated page context
//  */
// export function update_page_context(route = {}) {
//   current_page_context = {
//     ...current_page_context,
//     type: route_to_page_type(route),
//     template: get_template_from_route(route),
//     category: get_category_from_route(route),
//     title: get_page_title(route),
//     id: get_page_id(route),
//     url: get_page_url(),
//     referrer: get_referrer()
//   };

//   return { ...current_page_context };
// }

// /**
//  * Get current page context
//  * @returns {Object} - Current page context
//  */
// export function get_page_context() {
//   return { ...current_page_context };
// }

// /**
//  * Map route to page type using configured mapping
//  * @param {Object} route - Vue Router route object
//  * @returns {string} - Page type
//  */
// function route_to_page_type(route) {
//   if (!route || !route.path) {
//     return ANALYTICS_CONFIG.page_type_map['default'] || 'support_page';
//   }

//   const path = route.path.toLowerCase();
//   const name = (route.name || '').toLowerCase();
//   const meta_type = (route.meta && route.meta.page_type) || '';

//   // Check route meta first
//   if (meta_type && ANALYTICS_CONFIG.page_type_map[meta_type]) {
//     return ANALYTICS_CONFIG.page_type_map[meta_type];
//   }

//   // Check route name
//   if (name && ANALYTICS_CONFIG.page_type_map[name]) {
//     return ANALYTICS_CONFIG.page_type_map[name];
//   }

//   // Check path patterns
//   if (path === '/' || path === '') {
//     return ANALYTICS_CONFIG.page_type_map['home'];
//   }

//   if (path.includes('search')) {
//     return ANALYTICS_CONFIG.page_type_map['search'];
//   }

//   if (path.includes('category') || path.includes('categories')) {
//     return ANALYTICS_CONFIG.page_type_map['category'];
//   }

//   if (path.includes('article') || path.includes('blog')) {
//     return ANALYTICS_CONFIG.page_type_map['article'];
//   }

//   if (path.includes('download')) {
//     return ANALYTICS_CONFIG.page_type_map['download'];
//   }
//   return ANALYTICS_CONFIG.page_type_map['default'] || 'support_page';
// }

// /**
//  * Get template name from route
//  * @param {Object} route - Vue Router route object
//  * @returns {string} - Template name
//  */
// function get_template_from_route(route) {
//   return (route.meta && route.meta.template) || route.name || (route.component && route.component.name) || '';
// }

// /**
//  * Get category from route
//  * @param {Object} route - Vue Router route object
//  * @returns {string} - Category name
//  */
// function get_category_from_route(route) {
//   return (route.meta && route.meta.category) || (route.params && route.params.category) || '';
// }

// /**
//  * Get page title
//  * @param {Object} route - Vue Router route object
//  * @returns {string} - Page title
//  */
// function get_page_title(route) {
//   if (typeof document === 'undefined') {
//     return (route.meta && route.meta.title) || '';
//   }

//   return (route.meta && route.meta.title) || document.title || '';
// }

// /**
//  * Get page ID (unique identifier for page)
//  * @param {Object} route - Vue Router route object
//  * @returns {string} - Page ID
//  */
// function get_page_id(route) {
//   if (!route) {
//     return '';
//   }

//   // Use provided page_id from meta
//   if (route.meta && route.meta.page_id) {
//     return route.meta.page_id;
//   }

//   // Use article ID if present
//   if (route.params && route.params.id) {
//     return String(route.params.id);
//   }

//   // Use path as fallback
//   return route.path || '';
// }

// /**
//  * Get current page URL
//  * @returns {string} - Current URL
//  */
// function get_page_url() {
//   if (typeof window === 'undefined') {
//     return '';
//   }

//   return window.location.href;
// }

// /**
//  * Get referrer
//  * @returns {string} - Referrer URL
//  */
// function get_referrer() {
//   if (typeof document === 'undefined') {
//     return '';
//   }

//   return document.referrer || '';
// }

// /**
//  * Build site context object
//  * @param {Object} overrides - Override values for site context
//  * @returns {Object} - Site context
//  */
// export function build_site_context(overrides = {}) {
//   return {
//     brand: overrides.brand || ANALYTICS_CONFIG.site.brand,
//     region: overrides.region || ANALYTICS_CONFIG.site.region,
//     country: overrides.country || ANALYTICS_CONFIG.site.country,
//     language: overrides.language || ANALYTICS_CONFIG.site.language,
//     environment: overrides.environment || ANALYTICS_CONFIG.site.environment,
//     siteType: overrides.siteType || ANALYTICS_CONFIG.site.siteType,
//     userLoginState: overrides.userLoginState !== undefined ? overrides.userLoginState : ANALYTICS_CONFIG.site.userLoginState,
//     employee: overrides.employee !== undefined ? overrides.employee : ANALYTICS_CONFIG.site.employee,
//     provider: overrides.provider || ANALYTICS_CONFIG.site.provider
//   };
// }

// /**
//  * Build complete page context payload
//  * @returns {Object} - Complete context payload
//  */
// export function build_context_payload() {
//   return {
//     page: get_page_context(),
//     site: build_site_context()
//   };
// }

/**
 * Page Context Utilities
 * Enterprise route-aware analytics context manager
 */

import {
  ANALYTICS_CONFIG,
  REGION_MAP
} from './constants.js';

/**
 * Cached current page context
 */
let current_page_context = {
  type: '',
  template: '',
  category: '',
  title: '',
  id: '',
  url: '',
  referrer: ''
};

/**
 * Initialize page context
 * @param {Object} route
 * @returns {Object}
 */
export function initialize_page_context(route = {}) {
  const page_context = {
    type: route_to_page_type(route),
    template: get_template_from_route(route),
    event: route_to_page_event(route),
    category: get_category_from_route(route),
    title: get_page_title(route),
    id: get_page_id(route),
    url: get_page_url(),
    referrer: get_referrer()
  };

  current_page_context = {
    ...page_context
  };

  return page_context;
}

/**
 * Update page context on route change
 * @param {Object} route
 * @returns {Object}
 */
export function update_page_context(route = {}) {
  current_page_context = {
    ...current_page_context,
    type: route_to_page_type(route),
    template: get_template_from_route(route),
    event: route_to_page_event(route),
    category: get_category_from_route(route),
    title: get_page_title(route),
    id: get_page_id(route),
    url: get_page_url(),
    referrer: get_referrer()
  };

  return {
    ...current_page_context
  };
}

/**
 * Get current page context
 * @returns {Object}
 */
export function get_page_context() {
  return {
    ...current_page_context
  };
}

/**
 * Map route to page type
 * Uses regex route matching
 * @param {Object} route
 * @returns {string}
 */
function route_to_page_type(route) {
  if (!route || !route.path) {
    return 'support_page';
  }

  const path = route.path;

  const matched_route =
    ANALYTICS_CONFIG.route_page_type_map.find(
      (route_config) =>
        route_config.match.test(path)
    );

  if (matched_route) {
    return matched_route.type;
  }

  return 'support_page';
}

function route_to_page_event(route) {
  if (!route || !route.path) {
    return 'support_page';
  }

  const path = route.path;

  const matched_route =
    ANALYTICS_CONFIG.route_page_type_map.find(
      (route_config) =>
        route_config.match.test(path)
    );

  if (matched_route) {
    return matched_route.event;
  }

  return 'support_page';
}

/**
 * Get template name from route
 * @param {Object} route
 * @returns {string}
 */
function get_template_from_route(route) {
  if (!route || !route.path) {
    return 'default';
  }

  const path = route.path;

  const matched_route =
    ANALYTICS_CONFIG.route_page_type_map.find(
      (route_config) =>
        route_config.match.test(path)
    );

  if (matched_route) {
    return matched_route.template;
  }

  return (
    (route.meta &&
      route.meta.template) ||
    route.name ||
    'default'
  );
}

/**
 * Get category from route
 * @param {Object} route
 * @returns {string}
 */
function get_category_from_route(route) {
  return (
    (route.meta &&
      route.meta.category) ||
    (route.params &&
      route.params.category) ||
    ''
  );
}

/**
 * Get page title
 * @param {Object} route
 * @returns {string}
 */
function get_page_title(route) {
  if (typeof document === 'undefined') {
    return (
      (route.meta &&
        route.meta.title) ||
      ''
    );
  }

  return (
    (route.meta &&
      route.meta.title) ||
    document.title ||
    ''
  );
}

/**
 * Get unique page ID
 * @param {Object} route
 * @returns {string}
 */
function get_page_id(route) {
  if (!route) {
    return '';
  }

  if (
    route.meta &&
    route.meta.page_id
  ) {
    return route.meta.page_id;
  }

  if (
    route.params &&
    route.params.id
  ) {
    return String(route.params.id);
  }

  return route.path || '';
}

/**
 * Get current URL
 * @returns {string}
 */
function get_page_url() {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.location.href;
}

/**
 * Get referrer URL
 * @returns {string}
 */
function get_referrer() {
  if (typeof document === 'undefined') {
    return '';
  }

  return document.referrer || '';
}

/**
 * Parse region data from route
 * @param {Object} route
 * @returns {Object}
 */
function get_region_data(route) {
  // const region = route?.params?.region || "en-us";
  const region =
  route &&
  route.params &&
  route.params.region
    ? route.params.region
    : 'en-us';

  if (!region) {
    return {
      language: 'en',
      country: 'IN',
      region: 'APAC'
    };
  }

  return (
    REGION_MAP[region] || {
      language: 'en',
      country: 'IN',
      region: 'APAC'
    }
  );
}

/**
 * Build site context
 * @param {Object} route
 * @param {Object} overrides
 * @returns {Object}
 */
export function build_site_context(
  route = {},
  overrides = {}
) {
  const region_data =
    get_region_data(route);
    

  return {
    brand:
      overrides.brand ||
      ANALYTICS_CONFIG.site.brand,

    region:
      overrides.region ||
      region_data.region ||
      ANALYTICS_CONFIG.site.region,

    country:
      overrides.country ||
      region_data.country ||
      ANALYTICS_CONFIG.site.country,

    language:
      overrides.language ||
      region_data.language ||
      ANALYTICS_CONFIG.site.language,

    environment:
      overrides.environment ||
      ANALYTICS_CONFIG.site.environment,

    siteType:
      overrides.siteType ||
      ANALYTICS_CONFIG.site.siteType,

    userLoginState:
      overrides.userLoginState !==
      undefined
        ? overrides.userLoginState
        : ANALYTICS_CONFIG.site
            .userLoginState,

    employee:
      overrides.employee !==
      undefined
        ? overrides.employee
        : ANALYTICS_CONFIG.site
            .employee,

    provider:
      overrides.provider ||
      ANALYTICS_CONFIG.site.provider
  };
}

/**
 * Build complete analytics payload
 * @param {Object} route
 * @returns {Object}
 */
export function build_context_payload(
  route = {}
) {
  return {
    page: get_page_context(),

    site: build_site_context(
      route
    )
  };
}